import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { Typography, Button, IconButton } from "@mui/material";

import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";

//Icons
import { ReactComponent as ChevronLeft } from "../../assets/icons/svg/chevron-left.svg";
import { ReactComponent as ChevronRight } from "../../assets/icons/svg/chevron-right.svg";

//Sections
import RecipeHistory from "./sections/RecipeHistory";
import Nutrition from "./sections/Nutrition";
import Expenses from "./sections/Expenses";

//Modals
import CustomModal from "../modal/CustomModal";
import PlusModal from "../plus/PlusModal";
import DateSelectModal from "./modals/DateSelectModal";

export const InsightsPage = ({ auth: { user }, plus: { isPlus } }) => {
  const navigate = useNavigate();

  const [currentDate, setCurrentDate] = useState(new Date());
  const [showDateSelectModal, setShowDateSelectModal] = useState(false);
  //Todays macro targets at top
  //Planned meals
  //Daily macro history

  const formatDay = (date) => {
    return date.toLocaleDateString("en-US", { weekday: "long" });
  };

  const formatDate = (date) => {
    const day = date.getDate();
    const suffix = ["th", "st", "nd", "rd"][day % 10 > 3 ? 0 : (((day % 100) - (day % 10) !== 10) * day) % 10];
    return date.toLocaleDateString("en-US", { month: "long", day: "numeric" }).replace(/\d+/, day + suffix);
  };

  const changeDate = (days) => {
    const newDate = new Date(currentDate);
    newDate.setDate(newDate.getDate() + days);
    setCurrentDate(newDate);
  };

  const handleCalendarDateChange = (date) => {
    setCurrentDate(date);
    setShowDateSelectModal(false);
  };

  const handleCloseDateSelectModal = () => {
    setShowDateSelectModal(false);
  };

  const handleCloseComingSoon = () => {
    navigate("/");
  };

  useEffect(() => {
    const now = new Date();
    const localDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    setCurrentDate(localDate);
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="py-[4rem] md:py-0 md:pl-[5rem]">
      <Helmet>
        <title>Insights</title>
      </Helmet>
      <CustomModal
        open={!isPlus}
        handleClose={handleCloseComingSoon}
        border={false}
        type="bottom"
        parentClassNameOverride="md:min-w-[600px]"
      >
        <PlusModal />
      </CustomModal>
      <CustomModal open={showDateSelectModal} handleClose={handleCloseDateSelectModal} type="bottomToCentered">
        <DateSelectModal
          onDateSelect={handleCalendarDateChange}
          onClose={handleCloseDateSelectModal}
          dateFromParent={currentDate}
        />
      </CustomModal>
      <div className="w-full flex flex-col md:p-8 gap-4 bg-neutral-50 min-h-screen">
        <div className="w-full flex flex-row justify-between border border-separator items-center p-4 md:rounded-md shadow-sm bg-background">
          <IconButton onClick={() => changeDate(-1)} className="p-0 pr-2 hover:bg-transparent" disableRipple>
            <ChevronLeft className="h-4 fill-secondaryText" />
          </IconButton>
          <div className="w-full">
            <Button
              className="p-0 hover:bg-transparent flex flex-col items-start text-start mx-4"
              onClick={() => setShowDateSelectModal(true)}
              disableRipple
            >
              <div className="w-full">
                <div>
                  <Typography variant="subtitle1" className="text-secondaryText leading-none">
                    {formatDay(currentDate)}
                  </Typography>
                  <Typography variant="h5">{formatDate(currentDate)}</Typography>
                </div>
              </div>
            </Button>
          </div>

          <IconButton onClick={() => changeDate(1)} className="p-0 hover:bg-transparent" disableRipple>
            <ChevronRight className="h-4 fill-secondaryText" />
          </IconButton>
        </div>
        {isPlus ? (
          <div className=" w-full flex flex-col xl:flex-row gap-4 xl:gap-8 items-start justify-start">
            <div className="w-full flex flex-col gap-4 md:gap-16 items-start justify-start">
              <div className="w-full">
                <Nutrition currentDate={currentDate} setShowDateSelectModal={setShowDateSelectModal} />
              </div>
              <div className="w-full xl:hidden">
                <RecipeHistory date={currentDate} />
              </div>
              {false && (
                <div className="w-full">
                  <Expenses />
                </div>
              )}
            </div>
            <div className="w-full hidden xl:block">
              <RecipeHistory date={currentDate} />
            </div>
          </div>
        ) : (
          <div className=" w-full flex flex-col xl:flex-row gap-4 xl:gap-8 items-start justify-start">
            <div className="w-full flex flex-col gap-16 items-start justify-start">
              <div className="w-full">
                <Nutrition currentDate={currentDate} setShowDateSelectModal={setShowDateSelectModal} />
              </div>
              <div className="w-full xl:hidden">
                <RecipeHistory date={currentDate} />
              </div>
              {false && (
                <div className="w-full">
                  <Expenses />
                </div>
              )}
            </div>
            <div className="w-full hidden xl:block">
              <RecipeHistory date={currentDate} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

InsightsPage.propTypes = {
  data: PropTypes.array.isRequired,
  auth: PropTypes.object.isRequired,
  plus: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  plus: state.plus,
});

export default connect(mapStateToProps)(InsightsPage);
